/**
 * MSW handlers — payment proof domain.
 *
 * Placeholder: real handlers land as cases demand them. The e2e skill
 * activates specific scenarios via overrides (`worker.use(...)` in the
 * browser, `server.use(...)` in Node) — see `e2e/helpers/mockApi.ts`.
 */
export const paymentProofHandlers = []
